// extracted by mini-css-extract-plugin
module.exports = {"pending-sync":"styles_pending-sync__3BH0U"};